import React, { useEffect, useMemo, useState } from 'react';
import { StyledLoadCompleteProducts } from './styles';
import { ProductData } from 'utils/types';
import { LoadCompleteMainProduct } from './Main';
import { LoadCompleteSubProducts } from './Sub';

export type ILoadCompleteProductsProps = {
  productList: ProductData[];
};

export const LoadCompleteProducts: React.FC<ILoadCompleteProductsProps> = ({
  productList,
}) => {
  const [mainProduct, setMainProduct] = useState<ProductData>();
  const [subProducts, setSubProducts] = useState<ProductData[]>([]);

  useEffect(() => {
    if (!productList || productList.length === 0) return;

    setMainProduct(productList[0]);
    setSubProducts(productList.slice(1));
  }, [productList]);

  const hasSubProducts = useMemo(
    () => subProducts && subProducts?.length > 0,
    [subProducts],
  );
  return (
    <StyledLoadCompleteProducts
      className={'products-section'}
      justifyContent={hasSubProducts ? 'space-between' : 'center'}
    >
      {mainProduct && <LoadCompleteMainProduct product={mainProduct} />}
      {hasSubProducts && <LoadCompleteSubProducts products={subProducts} />}
    </StyledLoadCompleteProducts>
  );
};
